<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { createConsumer } from '@rails/actioncable';
import KanbanBoard from './KanbanBoard.vue';

const store = useStore();

const accountId = computed(() => store.getters.getCurrentAccount?.id);
const currentUser = computed(() => store.getters.getCurrentUser);
const loadError = computed(() => store.getters['kanban/uiFlags']?.loadError);

let subscription = null;
let ownedConsumer = null;

function getConsumer() {
  if (window.chatwootActionCable?.consumer) {
    return { consumer: window.chatwootActionCable.consumer, owned: false };
  }
  const { websocketURL = '' } = window.chatwootConfig || {};
  const wsUrl = websocketURL ? `${websocketURL}/cable` : undefined;
  return { consumer: createConsumer(wsUrl), owned: true };
}

onMounted(() => {
  const { consumer, owned } = getConsumer();
  if (owned) ownedConsumer = consumer;

  subscription = consumer.subscriptions.create(
    {
      channel: 'KanbanChannel',
      account_id: accountId.value,
      user_token: currentUser.value?.pubsub_token,
    },
    {
      received(data) {
        if (data.type === 'card_moved') {
          store.dispatch('kanban/handleCardMovedEvent', data);
        } else if (data.type === 'card_updated') {
          store.dispatch('kanban/handleCardUpdatedEvent', data);
        }
      },
    }
  );
});

onUnmounted(() => {
  subscription?.unsubscribe();
  ownedConsumer?.disconnect();
});
</script>

<template>
  <div class="flex flex-col h-full min-h-0 overflow-hidden bg-n-surface-2">
    <div
      v-if="loadError"
      class="m-4 p-3 rounded-md bg-n-ruby-2 border border-n-ruby-6 text-sm text-n-ruby-11"
    >
      {{ loadError }}
    </div>
    <KanbanBoard class="flex-1 min-h-0" />
  </div>
</template>
